<template>
  <div id="experience" class="relative bg-white dark:bg-gray-800 p-8 rounded-2xl shadow-lg border dark:border-gray-700 mb-8">
    <!-- Section Title with Underline Effect -->
    <h2 class="text-3xl font-bold text-gray-900 dark:text-gray-100 relative inline-block mb-6">
      Experience
      <span class="absolute left-0 bottom-0 w-full h-1 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full"></span>
    </h2>

    <div v-for="(company, index) in experiences" :key="index">
      <h3 class="text-2xl font-semibold text-gray-900 dark:text-gray-100">{{ company[0].company }}</h3>

      <ul class="mt-3 space-y-6">
        <li v-for="(job, idx) in company" :key="idx" class="p-5 bg-gray-100 dark:bg-gray-900 rounded-lg shadow">
          <h3 class="text-xl font-medium text-gray-900 dark:text-gray-100">{{ job.position }}</h3>
          <p class="text-gray-600 dark:text-gray-400 text-sm mb-3">{{ job.duration }}</p>
          <ul class="list-disc ml-6 mt-2 space-y-3.5">
            <li v-for="(achieved, domain) in job.description" :key="domain" class="text-gray-600 dark:text-gray-300">
              <div>
                <p class="font-semibold text-gray-900 dark:text-gray-100">{{ domain }}</p>
                <p class="text-gray-700 dark:text-gray-400">{{ achieved }}</p>
              </div>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExperienceSection',
  data() {
    return {
      experiences: [
          [
            {
              position: 'Software Engineer',
              company: 'SystemsD',
              duration: 'Oct 2024 - Present',
              description: {}
            },
            {
              position: 'Associate Software Engineer',
              company: 'SystemsD',
              duration: 'Dec 2023 - Oct 2024',
              description: {
                "Frontend Development": "Designing and implementing responsive user interfaces using Svelte and Vue.",
                "Backend Development": "Developing and managing robust backend systems with Django, Laravel, and Python-Falcon.",
                "Database Management": "Ensuring optimal performance and integrity of MySQL, Postgres, and firebase databases.",
                "Cloud Services": "Deploying and managing applications on AWS, with experience using Docker for containerization.",
                "Client Communication": "Engaging with clients via Trello, Slack, and JIRA to ensure project goals and deliverables are met.",
                "Servers": "Worked with Nginx and Apache servers. Handled Staging and Prod deployments",
                "Performance Monitoring tools": "New Relic, Bugsnag",
                "Email Services": "Mailchimp, Postmark"
              }
            },

          ]
      ]
    };
  },
};
</script>
